
<template>
  <div class="table-responsive lead_table" style="overflow:initial;" ref="formContainer">
    <table class="table table-hover" id="dataTable" cellspacing="0" >
      <thead style=" border-bottom: 1px solid #93a8d6; border-top: 1px solid #93a8d6;">
        <tr style="background-color: #f4f8fa;">
          <td class="text-left" v-if="flag && checkboxAll">
            <input type="checkbox" class="bg-default" style="cursor: pointer" value="1" v-on:change="changeAllChecboxes()" id="user_parent_row" name="" />
          </td>
          <td class="text-left" v-else-if="flag && !checkboxAll">
            <input type="checkbox" :indeterminate.prop="true" class="bg-default uncheckBox" style="cursor: pointer" value="1" v-on:change="changeAllChecboxes($event)" id="user_parent_row" name="" />
          </td>
          <td v-if="flag"></td>
          <td @click="sort('company')">
            Organization
            <span style="cursor: pointer" v-if="flag">
              <svg width="9" height="11" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.98553 8.11346C3.88557 8.11365 3.78869 8.07884 3.71172 8.01506L1.14479 5.87595C1.05742 5.80333 1.00247 5.69898 0.992045 5.58585C0.981615 5.47272 1.01655 5.36008 1.08917 5.27272C1.16179 5.18535 1.26614 5.1304 1.37927 5.11997C1.49239 5.10954 1.60503 5.14448 1.6924 5.2171L3.98553 7.13374L6.27866 5.28555C6.32242 5.25001 6.37277 5.22347 6.42682 5.20746C6.48087 5.19145 6.53756 5.18627 6.59361 5.19224C6.64967 5.1982 6.704 5.21518 6.75347 5.24221C6.80294 5.26924 6.84658 5.30578 6.88189 5.34972C6.92107 5.39371 6.95074 5.44532 6.96905 5.50131C6.98736 5.5573 6.9939 5.61647 6.98828 5.67511C6.98266 5.73375 6.96499 5.79059 6.93637 5.84208C6.90776 5.89358 6.86882 5.9386 6.82199 5.97435L4.25506 8.04073C4.17587 8.09443 4.08098 8.12003 3.98553 8.11346Z"
                  fill="#707070" />
                <path
                  d="M3.99494 0.522284C4.0949 0.522088 4.19178 0.556902 4.26875 0.620682L6.83568 2.7598C6.92305 2.83241 6.97799 2.93677 6.98842 3.04989C6.99885 3.16302 6.96392 3.27566 6.8913 3.36303C6.81868 3.45039 6.71433 3.50534 6.6012 3.51577C6.48808 3.5262 6.37544 3.49126 6.28807 3.41864L3.99494 1.502L1.70181 3.35019C1.65805 3.38573 1.6077 3.41227 1.55365 3.42828C1.49959 3.4443 1.44291 3.44947 1.38686 3.44351C1.3308 3.43754 1.27647 3.42056 1.227 3.39353C1.17753 3.3665 1.13388 3.32997 1.09858 3.28602C1.0594 3.24203 1.02973 3.19042 1.01142 3.13443C0.993112 3.07844 0.986565 3.01927 0.992188 2.96063C0.99781 2.90199 1.01548 2.84515 1.0441 2.79366C1.07271 2.74217 1.11165 2.69714 1.15848 2.6614L3.72541 0.595013C3.8046 0.541315 3.89949 0.515707 3.99494 0.522284Z"
                  fill="#707070" />
              </svg>
            </span>
          </td>
          <td @click="sort('name')">
            Login Date
            <span style="cursor: pointer" v-if="flag">
              <svg width="9" height="11" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.98553 8.11346C3.88557 8.11365 3.78869 8.07884 3.71172 8.01506L1.14479 5.87595C1.05742 5.80333 1.00247 5.69898 0.992045 5.58585C0.981615 5.47272 1.01655 5.36008 1.08917 5.27272C1.16179 5.18535 1.26614 5.1304 1.37927 5.11997C1.49239 5.10954 1.60503 5.14448 1.6924 5.2171L3.98553 7.13374L6.27866 5.28555C6.32242 5.25001 6.37277 5.22347 6.42682 5.20746C6.48087 5.19145 6.53756 5.18627 6.59361 5.19224C6.64967 5.1982 6.704 5.21518 6.75347 5.24221C6.80294 5.26924 6.84658 5.30578 6.88189 5.34972C6.92107 5.39371 6.95074 5.44532 6.96905 5.50131C6.98736 5.5573 6.9939 5.61647 6.98828 5.67511C6.98266 5.73375 6.96499 5.79059 6.93637 5.84208C6.90776 5.89358 6.86882 5.9386 6.82199 5.97435L4.25506 8.04073C4.17587 8.09443 4.08098 8.12003 3.98553 8.11346Z"
                  fill="#707070" />
                <path
                  d="M3.99494 0.522284C4.0949 0.522088 4.19178 0.556902 4.26875 0.620682L6.83568 2.7598C6.92305 2.83241 6.97799 2.93677 6.98842 3.04989C6.99885 3.16302 6.96392 3.27566 6.8913 3.36303C6.81868 3.45039 6.71433 3.50534 6.6012 3.51577C6.48808 3.5262 6.37544 3.49126 6.28807 3.41864L3.99494 1.502L1.70181 3.35019C1.65805 3.38573 1.6077 3.41227 1.55365 3.42828C1.49959 3.4443 1.44291 3.44947 1.38686 3.44351C1.3308 3.43754 1.27647 3.42056 1.227 3.39353C1.17753 3.3665 1.13388 3.32997 1.09858 3.28602C1.0594 3.24203 1.02973 3.19042 1.01142 3.13443C0.993112 3.07844 0.986565 3.01927 0.992188 2.96063C0.99781 2.90199 1.01548 2.84515 1.0441 2.79366C1.07271 2.74217 1.11165 2.69714 1.15848 2.6614L3.72541 0.595013C3.8046 0.541315 3.89949 0.515707 3.99494 0.522284Z"
                  fill="#707070" />
              </svg>
            </span>
          </td>
         
        </tr>
      </thead>
      <tbody>
        <tr  v-if="isLoader" id="table_row" >
          <td colspan="17">
            <b-skeleton-wrapper >
                <b-skeleton height="40px" ></b-skeleton>   
                <b-skeleton height="40px"></b-skeleton>  
                <b-skeleton height="40px"></b-skeleton>                                     
            </b-skeleton-wrapper> 
          </td>
        </tr>
        <tr v-show="!isLoader" v-for="(demo, index) in demoRequests" :demo="demo" :key="index" :style="`border-left: 5px solid #${demo.color}`" v-bind:class="[demo.id ? 'id-' + demo.id : '']" style="height: 63px;">
          <!-- Check Box -->
          <td>{{ demo.name }}</td>
          <td>{{ demo.login_at | formatDate}}</td>
         
        </tr>
        <tr v-if="demoRequests.length < 1 && !isLoader" style="height: 32.2vh">
          <td colspan="15">
            <h6 class="text-center">No Data Found!</h6>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Pagination  -->
      <div v-if="!isLoader" class="row mt-1 justify-content-end d-flex align-items-center px-3">
        <div class="pt-0 display-rows">
          <span class="pr-3 font-weight-light">Total Organizations</span>
          <span class="pr-5 color-default text-decoration-underline font-weight-bold">{{ total }}</span>
          <span class="pr-3 font-weight-light">Display Rows</span><span class="pr-5 mr-3 color-default font-weight-bold text-decoration-underline">{{ totalRows }}</span>
        </div>
        <paginate  v-show="totalRows > 0" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''" :first-button-text="''" :last-button-text="''" :first-last-button="true" :container-class="'pagination pagination-sm mb-0'" :page-class="'page-item'" :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'" :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
      </div>
  </div>
</template>

<script>
  import moment from "moment";
  import $ from "jquery";
import axios from 'axios';
  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });
  
  export default {
    props: [
      "demo",
      "demoRequests",
      "totalPages",
      "page",
      "title",
      "flag",
     
      "total",
      "totalRows",
      "assign_filter",
      "crm_id",
      "setskeletonLoader",
      "tag",
    ],
    data() {
      return {
        isLoader: true,
        myDate: "",
        st: "",
        role: '',
        show: true,
        dots: false,
        showstatus: false,
        upHere: false,
        checkAll: true,
        search: "",
        demo_id: "",
        edit_id: "",
        lead_status: "",
        lead_id: "",
        awaitingSearch: false,
        note: "",
        note_date: "",
        selectTab: "",
        message: "",
        created_at: "",
        suitable_date: "",
        status: 'all',
        countUnchecked: 0,
        checkboxAll: true,
        sortDirection: {
          company: true,
          name: true,
          followup_date: true,
          demo_date_note: true,
        },
        adminUsers:[],
        value:[],
        showCog:false,
        cogTypes:[],
        cogOptionsSelected:[],
      };
    },
    computed: {
      currentPage: {
        get: function () {
          this.showstatus = false;
          this.selectTab = localStorage.getItem("tab");
          return this.page;
        },
        set: function () { },
      },
      tags: function(){
        return this.$store.getters["users/tags"];
      },
      showskLoader: function () {
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      }
    },
    mounted: function () {
     
    
      this.isLoader = this.setskeletonLoader;
      this.role = localStorage.getItem('role');
      this.showstatus =false;
      this.edit_id = false;
      if(hasPermission('lead_list')){
        const permission = {
          headers: {
            'X-Permission': 'lead_list'
          }
        };
        axios.get('/admin/users/get-all-users?role_id=' + 2,permission)
            .then((response) => {
              let res = response.data;
              this.adminUsers = res.data;
            });
      }
    },
    watch:{
      showskLoader: function () {
        this.selectTab = localStorage.getItem("tab");
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      }
    } ,
    
    methods: {
      setPage(page) {
        //  console.log(localStorage.getItem('setPageDirection'));
        this.$emit("setPage",page);
    
      },
     
      
    },
  };
</script>
<style>

  /* ul.dropdown-menu.dashboard-actions.show {
    transform: translate3d(-132px, -240px, 0px) !important;
  } */
  .form-control {
    font-size: 13px;
  }

  .popover {
    white-space: pre-line;
    max-width: 221.34px;
    font-family: Mulish, sans-serif;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid #9fb4c3;
    border-radius: 8px;
    padding: 8px;
  }

  /* .tooltip {
    border: 1px solid black;
  } */

  .demo {
    margin-top: 5px;
    background: azure;
  }

  .dropdown {
    position: relative;
    display: inline-block;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: white;
    width: 140px;
    border-radius: 10px;
    border: 1px solid #b6c7d2;
    right: 100%;
    z-index: -1;
    margin-top: -30px;
  }

  .dropdown-content button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0px 0 5px 15px;
  }

  .dropdown-content button:hover {
    border-radius: 2px;
    background-color: #edf2f5;
  }

  .dropdown:hover .dropdown-content {
    display: block;
  }

  a.btn:focus {
    background-color: #48a6a6;
    color: white;
  }

  .dropdown-menu a:hover {
    border-radius: 2px;
    color: white;
    background-color: #48a6a6;
  }

  .discovery_status {
    color: #a682b2;
    font-weight: 700;
    font-size: 12px;
  }

  .qualified_status {
    color: #a682b2;
    font-weight: 700;
    font-size: 12px;
  }

  .dead_status {
    color: #a682b2;
    font-weight: 700;
    font-size: 12px;
  }

  .reject_status {
    color: #a682b2;
    font-weight: 700;
    font-size: 12px;
  }
  .tooltip{
    border: 0px solid black !important;
    top: -24px !important;
  }
  .tooltip.bs-tooltip-top{
     top: 24px !important;
  }
  .tooltip .tooltip-inner {
    max-width: 200px !important;
    padding: 0.25rem 0.5rem !important;
    color: #000000de !important;
    text-align: center !important;
    background-color: #dbddde !important;
    border-radius: 0.25rem !important;
    font-size: 12px !important;
    font-weight: 500 !important;
  }
</style>

<style scoped>

   table tr td:not(:nth-child(1)):not(:nth-child(4)){
     padding: 0.75rem 0.3rem;
   }
  tbody tr{
    font-size: 13px !important; 
  }
  /* table tr td:nth-child(1) {
   
    padding: 0.5rem 0.25rem;
  } */
 

  table tr td:nth-child(4) {
    width: 8.5% !important;
  }

  table tr td:nth-child(5) {
    width: 6% !important;
  }

  table tr td:nth-child(6) {
    width: 6% !important;
  }

  table tr td:nth-child(7) {
    width: 6% !important;
  }

  table tr td:nth-child(8) {
    width: 3% !important;
  }

  table tr td:nth-child(9) {
    width: 5% !important;
  }
   table tr td:nth-child(10) {
    width:7.5% !important;
  }

  table tr td:nth-child(11) {
    width: 7% !important;
  }

  table tr td:nth-child(12) {
    width: 7.5% !important;
    padding: 0;
  }

  table tr td:nth-child(13) {
    width: 8.5% !important;
  }

  table tr td:nth-child(14) {
    width: 5% !important;
  }

  table tr td:nth-child(15) {
    width: 5% !important;
    padding: 0;

  }

  table tr td:nth-child(16) {
    width: 11% !important;
    padding: 0.75rem 0.5rem;
  }
  table tr td:nth-child(17) {
    width: 1.5% !important;
    padding: 0.75rem 0.5rem;
  }
  .text-primary{
    color: rgb(72, 166, 166) !important;
  }
</style>